<template>
  <div class="baseContent-warp">
    <Card>
      <span slot="title">患者档案管理</span>
      <el-button slot="btn" icon="el-icon-refresh" @click="$refresh(getPatientsData)" class="fr">刷新</el-button>
      <div slot="content" class="wrap">
        <!-- 条件查询 -->
        <div class="search">
          <el-form :inline="true" :model="searchForm">
            <el-form-item label="患者名称">
              <el-input v-model="searchForm.patientName" placeholder="请输入患者名称" />
            </el-form-item>
            <el-form-item label="患者spu">
              <el-input v-model="searchForm.identityId" placeholder="请输入患者spu" />
            </el-form-item>
            <el-form-item label="手机号码">
              <el-input v-model="searchForm.phone" placeholder="请输入患者手机号" />
            </el-form-item>
            <el-form-item label="会员手机号">
              <el-input v-model="searchForm.memberPhone" placeholder="请输入会员手机号" />
            </el-form-item>
            <el-form-item label="患者来源">
              <el-select v-model="searchForm.source" placeholder="请选择患者来源">
                <el-option v-for="item in sourceOptions" :key="item" :label="item" :value="item" />
              </el-select>
            </el-form-item>
            <el-form-item label="最近就诊医生" v-if="deptId && (userInfo.type == 0 || userInfo.type == 1)">
              <el-select allow-create clearable v-model="searchForm.doctorName" placeholder="请选择医生" filterable
                default-first-option>
                <el-option v-for="item in doctorOptions" :key="item.value" :label="item.label" :value="item.label">
                  <span class="fl">{{ item.label }}</span>
                  <span class="select-flex">{{ item.phone }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
              <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!-- 操作按钮 -->
        <div class="button">
          <el-button icon="el-icon-plus" type="primary" @click="addFollowUpList"
            v-if="deptId && (userInfo.type == 0 || userInfo.type == 1)">批量随访计划</el-button>
        </div>
        <div>
          <!-- 患者列表 -->
          <el-table v-loading="loading" :data="patientList" :max-height="tableHeight"
            @selection-change="val => $handleSelectionChange(val, true)" ref="multipleTable" border>
            <el-table-column v-if="deptId && (userInfo.type == 0 || userInfo.type == 1)" type="selection" width="50"
              fixed="left" />
            <el-table-column type="index" label="序号" width="60" fixed="left" />
            <el-table-column prop="patientName" label="患者名称" fixed="left">
              <template slot-scope="scope">
                <div class="display-f align-i-c">
                  <span style="font-weight: bold; margin-right: 5px;">{{ scope.row.patientName }}</span>
                  <img v-if="scope.row.openId" :src="imgArr.weixin" width="16" height="16">
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="sex" label="性别" min-width="60">
              <template slot-scope="scope">{{ scope.row.sex == '0' ? '男' : '女' }}</template>
            </el-table-column>
            <el-table-column prop="birthday" label="生日" min-width="100" />
            <el-table-column label="年龄" min-width="80">
              <template slot-scope="scope">{{ scope.row.age }}岁<span
                  v-show="scope.row.age < 10 && scope.row.ageMth > 0">{{ scope.row.ageMth }}月</span></template>
            </el-table-column>
            <el-table-column prop="phone" label="电话" min-width="120" />
            <el-table-column prop="source" label="来源" min-width="100" />
            <el-table-column prop="createTime" label="创建时间" min-width="160" />
            <el-table-column prop="identityId" label="患者spu" min-width="60" />
            <el-table-column label="操作" width="430" fixed="right">
              <template slot-scope="scope">
                <el-button icon="el-icon-edit" type="primary" @click="editPatient(scope.row)">编辑</el-button>
                <!-- <el-button icon="el-icon-plus" type="primary" @click="followUpPlus(scope.row)" v-show="deptId && (userInfo.type == 0 || userInfo.type == 1)">随访计划</el-button> -->
                <el-button icon="el-icon-view" @click="toDetail(scope.row.patientId)">查看详情</el-button>
                <el-button @click="openMemberDialog(scope.row)">查看会员</el-button>
                <el-button @click="querySpu(scope.row)">查看spu</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="display-f mt20 size14 color1890 pointer">
            <div @click="lastPage">上一页</div>
            <div class="ml20" @click="nextPage">下一页</div>
          </div>
        </div>
        <!-- 新增或编辑弹框 -->
        <el-dialog class="dialogEdit" :title="dialogTitle" :visible.sync="dialogVisible" width="660px"
          :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
          <el-form :model="editForm" ref="editForm" label-width="80px" :rules="editFormRules" inline>
            <el-form-item label="患者姓名" prop="patientName">
              <el-input v-model.trim="editForm.patientName" placeholder="请输入患者名称" :disabled="disabled"/>
            </el-form-item>
            <el-form-item label="患者性别" prop="sex">
              <el-radio-group v-model="editForm.sex">
                <el-radio :label="'0'">男</el-radio>
                <el-radio :label="'1'">女</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="患者生日" prop="birthday">
              <el-date-picker v-model="editForm.birthday" value-format="yyyy-MM-dd" type="date" placeholder="选择出生日期"
                @blur="$computeAge(editForm.birthday, editForm)" :picker-options="pickerOptions" />
            </el-form-item>
            <el-form-item label="患者年龄" class="patientAge">
              <el-form-item prop="year">
                <el-input v-model.number="editForm.year" @blur="computeBirthday">
                  <template slot="append">岁</template>
                </el-input>
              </el-form-item>
              <el-form-item prop="month">
                <el-input v-model.number="editForm.month" @blur="computeBirthday">
                  <template slot="append">月</template>
                </el-input>
              </el-form-item>
            </el-form-item>
            <el-form-item label="手机号码" prop="phone">
              <el-input v-model.trim="editForm.phone" placeholder="请输入电话号码"  />
            </el-form-item>
            <el-form-item label="电话关系" prop="phoneRelated">
              <el-input v-model.trim="editForm.phoneRelated" placeholder="请输入电话与患者本人关系" />
            </el-form-item>
            <el-form-item label="患者微信" prop="vwName">
              <el-input v-model.trim="editForm.vwName" placeholder="请输入患者微信号码" />
            </el-form-item>
            <el-form-item label="身份证号" prop="idCard">
              <el-input v-if="editForm.idCardText" v-model.trim="editForm.idCardText" placeholder="填写有机会得券" disabled/>
              <el-input v-else v-model.trim="editForm.idCard" placeholder="填写有机会得券" />
            </el-form-item>
            <el-form-item label="医保卡号" prop="medicalInsurance">
              <el-input v-model.trim="editForm.medicalInsurance" placeholder="请输入患者医保卡号码" />
            </el-form-item>
            <el-form-item label="患者来源" prop="source">
              <el-select v-model="editForm.source" placeholder="请选择患者来源">
                <el-option v-for="item in sourceOptions" :key="item" :label="item" :value="item" />
              </el-select>
            </el-form-item>
            <el-form-item label="既往病史" prop="previousHistory">
              <el-input v-model.trim="editForm.previousHistory" type="textarea" placeholder="请输入患者居住地址" />
            </el-form-item>
            <el-form-item label="居住地址" prop="address">
              <el-input v-model.trim="editForm.address" type="textarea" placeholder="请输入患者居住地址" />
            </el-form-item>
          </el-form>
          <!-- 操作按钮 -->
          <span slot="footer" class="dialog-footer">
            <el-button v-if="dialogTitle == '新增患者'" type="success" @click="addSave(editForm)">保存新增</el-button>
            <el-button v-if="dialogTitle == '编辑患者'" type="success" @click="editSave(editForm)">保存编辑</el-button>
            <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
          </span>
        </el-dialog>
        <el-dialog class="dialogEdit" title="患者SPU" :visible.sync="SPUDialogObj.show" width="860px" :close-on-click-modal="false">
          <div>SPU ID:{{SPUDialogObj.identityId}}</div>
          <el-table class="mt20" :data="SPUDialogObj.patientList" border>
             <el-table-column prop="patientId" label="患者ID" />
             <el-table-column prop="patientName" label="患者姓名" />
             <el-table-column prop="phone" label="患者手机号码" />
             <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="addSPU(scope.row)">新建SPU</el-button>
                <el-button type="text" @click="openMoveDialog(scope.row)">移动至其他SPU</el-button>
              </template>
             </el-table-column>
          </el-table>
        </el-dialog>
        <el-dialog class="dialogEdit" title="转移至其他SPU" :visible.sync="moveDialogObj.show" width="400px" :close-on-click-modal="false">
          <div>
            <span>SPU：</span>
            <el-select v-model="moveDialogObj.identityId" filterable remote reserve-keyword placeholder="姓名/手机号/SPU ID" :remote-method="remoteMethod">
              <el-option v-for="item in moveDialogObj.options" :key="item.identityId" :value="item.identityId" :label="item.name">
                <span>{{ item.identityId }}</span>
                <span class="ml10">{{ item.name }}</span>
                <span class="ml10">{{ item.phone }}</span>
              </el-option>
            </el-select>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="moveDialogCancel">取 消</el-button>
            <el-button type="primary" @click="moveSPU">确定</el-button>
          </span>
        </el-dialog>
        <el-dialog class="dialogEdit" title="查看会员" :visible.sync="memberDialog.show" width="660px" :close-on-click-modal="false">
          <el-table class="mt20" :data="memberDialog.memberList" border>
             <el-table-column prop="memberName" label="会员姓名" />
             <el-table-column prop="phone" label="会员电话" />
             <el-table-column prop="bindDate" label="绑定时间" />
             <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="addBlacklist(scope.row)">添加黑名单</el-button>
              </template>
             </el-table-column>
          </el-table>
        </el-dialog>
      </div>
    </Card>
  </div>
</template>

<script lang="js">
import { patientList, patientAdd, patientEdit, patientInfo, addBlacklist,queryIdentityId,addIdentity,queryIdentity,updateIdentity,getMemberByPatientId } from "@/api/patient"; // 病人请求
import { validateName, validatePhone, validateIdCard, validateYear, validateMonth } from "@/utils/regexp" // 自定义验证
import { followUpAdd, followUpListAdd } from "@/api/followup"; // 获取随访请求
import { isNull, isEmptyArray,debounce } from "@/utils/validateBase";
import { Utils } from "@/utils/utils";
import { imgArr } from "@/assets/images/img";
export default {
  name: "Archive",
  data() {
    return {
      imgArr: imgArr,
      loading: true, // 加载中
      searchForm: { patientName: null, source: null, doctorName: null, phone: null,memberPhone:null,identityId:null }, // 查询表单
      patientList: [], // 患者列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      dialogTitle: null, // 弹框标题
      dialogVisible: false, // 新增或编辑弹框状态
      editForm: {}, // 新增或编辑表单
      multipleSelection: [], // 被选中行
      disabled: false, // 电话输入禁用
      sourceOptions: this.$sourceOptions, // 患者来源选项
      pickerOptions: { // 日期不可选范围
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      doctorOptions: [{ label: '-', value: '-', phone: '-' }], // 馆内医生列表
      editFormRules: {
        patientName: [{ required: true, validator: validateName, trigger: 'blur' }],
        phone: [{ required: true, validator: validatePhone, trigger: 'blur' }],
        sex: [{ required: true, message: '请选择患者性别', trigger: 'change' }],
        source: [{ required: true, message: "请选择患者来源", trigger: 'change' }],
        idCard: [{ required: false, validator: validateIdCard, trigger: 'blur' }],
        year: [{ required: false, validator: validateYear, trigger: 'blur' }],
        month: [{ required: false, validator: validateMonth, trigger: 'blur' }]
      }, // 表单验证规则
      deptId: this.$session.get('deptId'), // 医馆id
      userInfo: this.$session.get('user'), // 用户信息
      doctorInfo: this.$session.get('user').hospDoctorInfo, // 医生信息
      examPlanName: null, // 预计随访人员
      tableHeight: 0, // 表格最大高度
      cursorArr: [],//游标数组
      isLoadMore: true,//是否加载更多
      SPUDialogObj:{
        show:false,
        patientList:[],
        identityId:''
      },
      moveDialogObj:{
        show:false,
        options:[],
        search:'',
        identityId:'',
        patientId:''
      },
      memberDialog:{
        show:false,
        memberList:[],
      }
    };
  },
  created() {
    if (document.documentElement.clientWidth > 1360) {
      this.tableHeight = document.documentElement.clientHeight - 320;
    } else {
      this.tableHeight = document.documentElement.clientHeight - 380;
    }
    if (window.sessionStorage.getItem('patientListFilter')) {
      const info = JSON.parse(window.sessionStorage.getItem('patientListFilter'));
      this.searchForm = info.form
      this.pageSize = info.pageSize
      window.sessionStorage.removeItem('patientListFilter')
    } else {
      this.cursorArr.push(null)
    }
    this.getPatientsData(); // 页面初始化获取患者列表
    if (this.deptId && (this.userInfo.type == 0 || this.userInfo.type == 1)) this.$getDoctorOptions({ type: 0, status: 0 }); // 获取所有馆内在职医生
    // 判断预计随访人员
    if (this.userInfo.type == '0' && this.doctorInfo.assistantName) this.examPlanName = this.doctorInfo.assistantName;
    else this.examPlanName = this.userInfo.nickName;
  },
  methods: {
    // 请求所有患者列表
    async getPatientsData() {
      // if (!this.isLoadMore) return this.$message.warning('已经到最后一页了！')
      let params = { cursorIndex: this.cursorArr[this.cursorArr.length - 1], pageSize: this.pageSize, ...this.searchForm };
      let { data, code } = await patientList(params);
      if (code == 200) {
        this.cursorArr.push(isNull(data.cursorIndex) ? null : data.cursorIndex)
        this.patientList = isNull(data.patients) ? [] : data.patients
        this.isLoadMore = Utils.lt(this.patientList.length, this.pageSize) ? false : true
      }
      this.loading = false;
    },
    // 添加随访计划
    async followUpPlus(obj) {
      let params = {
        status: 0, patientId: obj.patientId, deptId: this.deptId,
        examPlanName: this.examPlanName, patientName: obj.patientName
      }
      let { code } = await followUpAdd(params);
      if (code == 200) this.$message.success('设置随访计划成功！');
      this.refreshCurrentPage()
    },
    // 批量添加随访计划
    addFollowUpList() {
      let selected = [...this.multipleSelection];
      let selectedPatient = [];
      if (selected.length == 0) this.$message.warning("您未选中任何患者");
      else {
        selected.forEach(patient => {
          selectedPatient.push({
            status: 0, patientId: patient.patientId, deptId: this.deptId,
            examPlanName: this.examPlanName, patientName: patient.patientName
          })
        });
        this.$confirm('确定给这些患者随访吗？').then(_ => {
          followUpListAdd(selectedPatient).then(res => {
            if (res.code == 200) {
              this.$message.success("批量添加随访计划成功！");
              this.refreshCurrentPage()
            }
          });
        }).catch(_ => { });
      }
    },
    toDetail(patientId) {
      const info = {
        form: this.searchForm,
        pageSize: this.pageSize
      }
      window.sessionStorage.setItem("patientListFilter", JSON.stringify(info))
      this.$router.push(`/patient/patientdetails?patientId=${patientId}`)
    },
    // 新增患者
    addPatient() {
      this.editForm = {
        patientName: null, age: null, birthday: null, phone: null, phoneRelated: null, idCard: null,
        medicalInsurance: null, source: null, vwName: null, sex: '0', address: null, previousHistory: null
      };
      this.disabled = false;
      this.dialogVisible = true;
      this.dialogTitle = "新增患者";
    },
    // 保存新增
    addSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          patientAdd(this.handle(true)).then(res => {
            let { code } = res;
            if (code == 200) this.$message.success("新增患者成功！");
            this.refresh()
            this.$refs['editForm'].resetFields();
            this.dialogVisible = false;
          })
        } else return false;
      })
    },
    // 处理参数
    handle(flag) {
      let params = JSON.parse(JSON.stringify(this.editForm));
      if (flag) params.sourceDeptId = this.$session.get('deptId');
      delete params.age;
      return params;
    },
    // 编辑患者信息
    async editPatient(row) {
      this.disabled = (row.realIdCard || row.idCard) ? true : false;
      let { data, code } = await patientInfo(row.patientId);
      if (code == 200) {
        let params = JSON.parse(JSON.stringify(data));
        this.$computeAge(params.birthday, params);
        this.editForm = params;
        this.editForm.idCardText = isNull(params.idCard) ? '' :params.idCard.slice(0, 6) + '********' + params.idCard.slice(-4)
        this.dialogTitle = "编辑患者";
        this.dialogVisible = true;
      }
    },
    async addBlacklist (row) {
      this.$confirm('此操作将该患者绑定会员添加至黑名单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        const { code } = await addBlacklist({ memberId: row.memberId })
        if (code == 200) {
          this.$message.success('添加黑名单成功')
          this.memberDialog.show = false
          this.memberDialog.memberList = []
        }
      }).catch(() => {})
    },
    // 保存患者修改
    editSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          patientEdit(this.handle()).then(res => {
            let { code } = res;
            if (code == 200) this.$message.success("修改患者成功！");
            this.refreshCurrentPage()
            this.$refs['editForm'].resetFields();
            this.dialogVisible = false;
          })
        } else return false;
      })
    },
    // 计算生日
    computeBirthday() {
      this.editForm.birthday = this.$computeBirthday(this.editForm.year, this.editForm.month);
    },
    /**
     * 上一页
     */
    lastPage() {
      this.isLoadMore = true
      if (this.cursorArr.length == 2) return this.$message.warning('已经到第一页了！！')
      this.cursorArr.splice(-2)
      this.getPatientsData()
    },
    /**
     * 搜索
     */
    handleSearch() {
      this.isLoadMore = true
      this.cursorArr = []
      this.cursorArr.push(null)
      this.getPatientsData()
    },
    /**
     * 重置
     */
    reset() {
      this.searchForm = {
        patientName: null, source: null, doctorName: null, phone: null,memberPhone:null,identityId:null
      }
      this.refresh()
    },
    /**
     * 刷新
     */
    refresh() {
      this.isLoadMore = true
      this.cursorArr = []
      this.cursorArr.push(null)
      this.getPatientsData()
    },
    /**
     * 刷新当前页
     */
    refreshCurrentPage() {
      this.isLoadMore = true
      this.cursorArr.pop()
      this.getPatientsData()
    },
    /**
    * 下一页
    */
    nextPage() {
      if (Utils.lt(this.patientList.length, this.pageSize)) return this.$message.warning('已经到最后一页了！')
      this.getPatientsData()
    },
    async querySpu(row){
      this.SPUDialogObj.identityId = ''
      let {code,data} = await queryIdentityId({identityId:row.identityId })
      if(code == 200){
        this.SPUDialogObj.patientList = data || []
        this.SPUDialogObj.show = true
        this.SPUDialogObj.identityId = row.identityId
      }
    },
    addSPU(row){
      this.$confirm('确定要新建SPU吗?', '新建SPU', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let {code} = await addIdentity({patientId:row.patientId})
          if(code==200){
            this.$message.success('新建成功')
            this.SPUDialogObj.show = false
            this.cursorArr = []
            this.getPatientsData()
          }
        }).catch(() => {
        });
    },
    remoteMethod:debounce(async function(val){
      let {code,data} = await queryIdentity({search:val})
      if(code ==200){
        this.moveDialogObj.options = data || []
      }
    },300),
    openMoveDialog(row){
      this.moveDialogObj.patientId = row.patientId
      this.moveDialogObj.show = true
      this.moveDialogObj.search = ''
      this.moveDialogObj.options = []
      this.moveDialogObj.identityId = ''
    },
    moveDialogCancel(){
      this.moveDialogObj.patientId = ''
      this.moveDialogObj.show = false
    },
    async moveSPU(){
      let params = {
        identityId:this.moveDialogObj.identityId,
        patientId:this.moveDialogObj.patientId
      }
      let {code} = await updateIdentity(params)
      if(code ==200){
          this.$message.success('操作成功')
          this.SPUDialogObj.show = false
          this.moveDialogObj.show = false
          this.cursorArr = []
          this.getPatientsData()
      }
    },
    async openMemberDialog(row){
      let { code,data } = await getMemberByPatientId({patientId:row.patientId})
      if(code ==200){
        this.memberDialog.memberList = data
        this.memberDialog.show = true
      }
    }
  },
};
</script>

<style lang="less" scoped>
.dialogEdit {
  .el-form-item {
    width: 50%;
    margin-right: 0;
  }
}
</style>